import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { showHiddenTables } from "../../../../services/Admin/TablesApi";

const RestoreTablesDialog = ({ open, onClose, onRestored }) => {
  const [tablesNumber, setTablesNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const reset = () => {
    setTablesNumber(1);
    setError(null);
  };

  const handleClose = () => {
    if (!loading) {
      reset();
      onClose && onClose();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const n = Number(tablesNumber);
    if (!Number.isFinite(n) || n <= 0 || !Number.isInteger(n)) {
      setError("يرجى إدخال عدد صحيح موجب للطاولات");
      return;
    }

    setLoading(true);
    try {
      const res = await showHiddenTables({ tables_number: n });
      onRestored && onRestored(res?.data ?? res);
      reset();
      onClose && onClose();
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء استرجاع الطاولات");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!open} onClose={handleClose} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>استرجاع الطاولات</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            سيتم استرجاع عدد الطاولات المحدد من الطاولات المخفية. تابع؟
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="عدد الطاولات المراد استرجاعها"
            type="number"
            fullWidth
            inputProps={{ min: 1 }}
            value={tablesNumber}
            onChange={(e) => setTablesNumber(e.target.value)}
            disabled={loading}
          />
          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            إلغاء
          </Button>
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={20} /> : "استرجاع"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default RestoreTablesDialog;
